import { render, staticRenderFns } from "./GraduatesNew.vue?vue&type=template&id=c807adf6&"
import script from "./GraduatesNew.vue?vue&type=script&lang=js&"
export * from "./GraduatesNew.vue?vue&type=script&lang=js&"
import style0 from "./GraduatesNew.vue?vue&type=style&index=0&id=c807adf6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports